import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CategoryService from "../../../Services/QRCodeServices/MenuCategory/CategoryService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Card, Col, Row } from "reactstrap";

const DetailMenuCategory = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log("🚀 ~ DetailMenuCategory ~ data:", data);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await CategoryService.detail(id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <BreadCrumb
            pageTitle="Menu Category"
            title="Menu Category Detail"
            breadcrumbItems={[{ title: "Back To List ", link: "/menu-category" }]}
          />
        </div>
        <Card className="p-3">
          <Row>
            <Col md={4} sm={7} xs={12}>
              <img src={data?.cloudR2ImagePath
?.getCDNUrl()} className="object-fit-cover"  style={{width:"150px"}} />
            </Col>
            <Col md={8}>
              <Row>
                <Col md={6} className="mb-2">
                  <h5 className="fw-bold">Category Name: </h5>
                  <h6 className="fw-normal">{data?.name}</h6>
                </Col>
                <Col md={6} className="mb-2">
                  <h5 className="fw-bold">Menu Type:</h5>
                  <h6 className="fw-normal">{data?.menuType}</h6>
                </Col>
                {/* <Col md={6} className="mb-2">
                  <h5 className="fw-bold">Integredient:</h5>
                  <h6 className="fw-normal">{data?.ingredients}</h6>
                </Col>
                <Col md={6} className="mb-2">
                  <h5 className="fw-bold">Price:</h5>
                  <h6 className="fw-normal">{data?.price}</h6>
                </Col>
                <Col md={6} className="mb-2">
                  <h5 className="fw-bold">Currency:</h5>
                  <h6 className="fw-normal">{data?.currency}</h6>
                </Col>
                <hr />
                <Col md={6} className="mb-2">
                  <h5 className="fw-bold">Description:</h5>
                  <p className="fw-normal">{data?.description}</p>
                </Col> */}
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default DetailMenuCategory;
